import { useEffect, useState } from "react";

// 初期状態は undefined として、SSR 時には未判定とする。
export function useInNativeApp() {
  const [isInNativeApp, setIsInNativeApp] = useState<boolean | undefined>(
    undefined,
  );
  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect -- Client-side detection pattern
    setIsInNativeApp(
      typeof document !== "undefined" &&
        document.documentElement.getAttribute("data-client") === "nativeapp",
    );
  }, []);
  return isInNativeApp;
}
